<template>
	<div>
		<!-- 标题 -->
		<div class="recordTitle">
			<p>缴费金额：¥13342</p>
			<p>缴费年度：2022年度</p>
			<p>缴费时间：02-22 18:00</p>
			<p>开票状态：xxxxxxx</p>
		</div>
		<!-- 开票记录表格 -->
		<div class="">
			<p class="specialTitle">开票记录</p>
			<!-- 特俗样式表格 -->
			<div class="infobody_body">
				<div class="table_head">
					<span>开票商品</span>
					<p></p>
					<span>开票金额</span>
					<p></p>
					<span>发票抬头</span>
					<p></p>
					<span>税号</span>
					<p></p>
					<span>公司名称</span>
					<p></p>
					<span>开户行</span>
					<p></p>
					<span>银行账号</span>
					<p></p>
					<span>购方地址</span>
					<p></p>
					<span>接受邮箱</span>
					<p></p>
					<span>状态</span>
				</div>
				<div class="table_list" v-for="(item,index) in tableList" :key="index">
					<!-- <p>无数据</p> -->
					<div class="innerTable" v-for="(key,index) in 10" :key="index">
					</div>
					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				tableList: [{
						date: '',
						content: '',
						status: '已拒绝',
						application: '查看',
						sqlcol: ['详情', '发票申请']
					},
					{
						date: '',
						content: '',
						status: '开票中',
						application: '查看',
						sqlcol: ['详情', '下载发票']
					},
					{
						date: '',
						content: '',
						status: '已开票',
						application: '',
						sqlcol: []
					}, {
						date: '',
						content: '',
						status: '未开票',
						application: '',
						sqlcol: []
					}
				]
			}
		},
	}
</script>

<style scoped>
	.recordTitle{
		display: flex;
		height: 80px;
		align-items: center;
		justify-content: space-evenly;
	}
	.recordTitle p{
		width: 25%;
		font-size: 14px;
		text-align: left;
	}
	.specialTitle{
		display: block;
		width: 100px;
		height: 40px;
		font-size: 15px;
		font-family: PingFangSC-Semibold, PingFang SC;
		font-weight: 600;
		color: #000000;
		line-height: 40px;
	}
	/* 信心变更主题内容 */
	.infobody_body {
		width: 100%;
		min-height: 100px;
		height: auto;
		background-color: #f9f9f9;
	}
	
	.table_head {
		display: flex;
		height: 50px;
		line-height: 50px;
	}
	
	.table_head span {
		flex: 1;
		background-color: #dce0e6;
		font-weight: bold;
		font-size: 15px;
	}
	
	.table_head p {
		height: 50px;
		width: 2px;
	}
	
	.table_list {
		width: 100%;
		height: 50px;
		line-height: 50px;
		display: flex;
		border-bottom: 1px solid #e9e9e9;
	}
	
	.innerTable{
		font-size: 14px;
		flex: 1;
	}
	.btninner{
		cursor: pointer;
	}
	.innerTable:nth-of-type(4){
		color: #4facfe;
	}
	.innerTable:last-child{
		color: #000;
		display: flex;
		align-items: center;
		justify-content: space-evenly;
	}
</style>
